import { memo } from 'react';

const ContainerFooter = ({ ...props }) => {
    return (
        <div className='stickysidemenu-footer'>        
            {props.children}         
        </div>
    );
}

export default memo(ContainerFooter);